import { useEffect, useRef } from "react";
import { getToken, http } from "@network/http";
import { useDispatch } from "noval";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";

export const useGetEnums = (lang) => {
  const { dispatch } = useDispatch();
  const { pathname } = useRouter();
  const hasFetched = useRef(false);
  const previousLang = useRef(lang);

  useEffect(() => {
    const getAllEnums = async () => {
      try {
        const res = await http.get(`/all-enums`);
        dispatch({ enums: res.data?.data });
        hasFetched.current = true;
      } catch (error) {
        console.error("Failed to fetch enums:", error);
      }
    };
    if (!hasFetched.current && pathname !== "/") {
      getAllEnums();
    } else if (hasFetched.current && lang !== previousLang.current) {
      getAllEnums();
    }

    previousLang.current = lang;
  }, [lang, pathname]);
};

export const useAuthenticationDispatcher = () => {
  const { lang } = useTranslation();
  const { dispatch } = useDispatch();

  useEffect(() => {
    const token = getToken();
    dispatch({ mainLoading: false });
    if (!token) {
      dispatch({ authLoad: false, isLoaded: true });
    }
    if (token) {
      dispatch("authentication", {
        lang,
        callback: ({ is_kyc_completed, is_iqama_updated }) => {
          dispatch({ isLoaded: true });
          if (!is_iqama_updated) {
            dispatch({ iqamaAlert: true });
          }
          if (!is_kyc_completed) {
            dispatch({ reminderOpen: true });
          }
        },
      });
    }
  }, []);
};
